<template>
    <v-container>
        <v-layout row v-if="error">
            <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-layout>
        <app-loading v-if="loading"></app-loading>
        <v-layout v-else row>

            <v-container fluid>
                <v-row dense>
                    <v-col
                            :cols="12"
                            v-if="segmentData"
                    >
<!--                        segment dash-->
                        <v-card :color="segmentData.colour">
<!--                            segment name-->
                            <v-card-title v-if="!editName" class="white--text">
                                {{segmentData.name}}
                                <v-btn @click="changeName" icon>
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-card-title v-else>
                                <v-text-field
                                        v-model="newSegmentName"
                                        class="white--text"
                                        clearable
                                        append-icon="check"
                                        @click:append="updateName"
                                ></v-text-field>
                            </v-card-title>
<!--                            add new contact-->
                            <v-card-actions>
                                <v-col cols="12" sm="12" md="12">
                                    <v-autocomplete
                                            v-model="selectedUser"
                                            :items="userNames"
                                            label="Add Contact"
                                            hide-details
                                            hide-selected
                                            single-line
                                            clearable
                                    ></v-autocomplete>
                                </v-col>
                            </v-card-actions>
<!--                            text arera -->
                            <v-card class="white">
                                <v-card-text>
                                    <v-textarea
                                            outlined
                                            label="New Text"
                                            v-model="textMessage"
                                    ></v-textarea>

                                    <!--  image upload button-->
                                    <v-layout row>
                                        <v-btn @click="loadContent" icon><v-icon>photo</v-icon></v-btn>
                                        <v-btn icon><v-icon>location_on</v-icon></v-btn>
                                    </v-layout>
<!--                                    picked image-->
                                    <v-card-text v-if="mediaUrl">
                                        <v-img contain :src="mediaUrl" aspect-ratio="3.7"></v-img>
                                    </v-card-text>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn  @click="sendMessageDialog = true" class="blue--text" outlined>Send Preview</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-card>
<!--                        users in segment-->
                        <v-card>
                            <v-list two-line>
                                <v-list-item
                                        v-for="item in usersInSegment"
                                        :key="item.phoneNumber"
                                >
                                    <v-list-item-avatar>
                                        <avatar class="white--text" :username="item.name"></avatar>
                                    </v-list-item-avatar>


                                    <v-list-item-content @click="loadUserData(item.phoneNumber)">
                                        <v-list-item-title>{{item.name }}</v-list-item-title>
                                        <v-list-item-subtitle>{{moment(item.lastActive)}}</v-list-item-subtitle>
                                      <v-list-item-subtitle>{{item.lastMessage}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn icon @click="removeUser(item.phoneNumber)">
                                            <v-icon>cancel</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-card>
<!--                        delete user-->
                        <v-card-actions>
                            <v-btn @click="deleteSegment" class="error" block outlined text>delete</v-btn>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-container>
            <v-dialog v-model="userDataDialog"
                      ref="dialog"
                      persistent
                      width="290px"
            >
                <v-card v-if="loadedUserData">
                    <v-card-title>
                        <div class="white black--text text-xs-center font-weight-thin headline">User Data</div>
                    </v-card-title>
                    <v-card-text>
                      {{loadedUserData}}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="outlined" router :to="'/numberPortal/' + phoneNumber +'/' + loadedUserData.phoneNumber">Load Profile</v-btn>
                        <v-btn class="outlined" @click="userDataDialog = false">close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="sendMessageDialog"
                      ref="dialog"
                      persistent
                      width="290px"
            >
                <v-card>
                    <v-card-title>
                        <div class="white
                        black--text
                        text-xs-center
                        font-weight-thin
                        headline">Broadcast</div>
                    </v-card-title>
                    <v-card-text>
                        <div class="subheading">{{textMessage}}</div>
                        <!-- picked image-->
                        <div v-if="mediaUrl">
                            <v-img contain :src="mediaUrl" aspect-ratio="2.5"></v-img>
                        </div>
                        <v-list v-for="user in usersInSegment" :key="user.phoneNumber">
                            <v-list-item>
                                <v-list-item-content>
                                    {{user.name}}
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  @click="sendMessageDialog = false">close</v-btn>
                        <v-btn  class="blue white--text"
                                :disabled="msgNotValid"
                                @click="sendText">
                            send
                            <v-icon>send</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="imageUploadDialog"
                      ref="dialog"
                      persistent
                      width="500px"
            >
                <v-card>
                    <img-uploader @imageLinkFound="addImageLink"></img-uploader>
                    <v-card-text v-if="mediaUrl">
                        <v-img contain :src="mediaUrl" aspect-ratio="1.7"></v-img>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancelImageUpload">cancel</v-btn>
                        <v-btn class="blue--text"
                               outlined
                               @click="imageUploadDialog = false">
                            Done
                        </v-btn>
                    </v-card-actions>
<!--                    image content components-->
                    <template>
                        <v-row>
                            <v-col cols="12" sm="6" offset-sm="3">
                                <v-card>
                                    <v-container fluid>
                                        <v-row>
                                            <v-col
                                                    v-for="n in content"
                                                    :key="n.created"
                                                    class="d-flex child-flex"
                                                    cols="4"
                                            >
                                                <v-card flat tile class="d-flex">
                                                    <v-img
                                                            :src="n.imageUrl"
                                                            aspect-ratio="1"
                                                            class="grey lighten-2"
                                                            @click="selectImgFromContent(n.imageUrl)"
                                                    >
                                                        <template v-slot:placeholder>
                                                            <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                            >
                                                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                            </v-row>
                                                        </template>
                                                    </v-img>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>

                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>
<script>
    import Avatar from "vue-avatar"
    import moment from "moment"
    import { v1 as uuidv1 } from 'uuid';
    import {getDoc, doc,deleteDoc, setDoc, addDoc, updateDoc, collection, onSnapshot} from "firebase/firestore";
    export default {
        props: ["phoneNumber", "uid", "segmentId"],
        components: {
            Avatar
        },
        data() {
            return {
                segmentData: undefined,
                editName: false,
                newSegmentName: undefined,
                users: [],
                selectedUser: undefined,
                selectedUserData: undefined,
                userNames: [],
                usersInSegment: [],
                userDataDialog: false,
                loadedUserData: undefined,
                textMessage: '',
                sendMessageDialog: undefined,
                imageUploadDialog: false,
                mediaUrl: undefined,
                content: []
            }
        },
        created () {
          let db = this.$store.state.db
          let segmentRef = doc(db, 'users', this.uid, 'provisionedNumbers', this.phoneNumber, 'segments', this.segmentId)
          onSnapshot(segmentRef, doc => {
                    if(doc.exists){
                        this.segmentData = doc.data ()
                    }
                })
          let segmentContactRef = collection(db, 'users', this.uid + '/provisionedNumbers/' + this.phoneNumber + '/segments/'+ this.segmentId + '/contacts')
          onSnapshot(segmentContactRef, res => {
                if (res && res.empty !== true) {
                    let users = []
                    res.docs.forEach(doc => {
                        let data = doc.data()
                        users.push(data)

                    })
                    this.usersInSegment = users
                } else {
                    this.usersInSegment = []
                }
            })
          // fetches contacts associated with this number
          let smsRef = collection(db, 'users', this.uid + '/provisionedNumbers/'+ this.phoneNumber + '/sms')
          onSnapshot(smsRef, res => {
            if (res && res.empty !== true) {
              let users = []
              let userNames = []
              res.docs.forEach(doc => {
                let data = doc.data()
                users.push(data)

              })
              this.users = users.sort((convoA, convoB) => {
                return convoB.lastActive - convoA.lastActive
              })
              users.forEach(user => {
                return userNames.push(user.name)
              })
              this.userNames = userNames
            }
          })
        },
        computed: {
            msgNotValid () {
                return !((this.usersInSegment.length !== 0) && (this.textMessage !== ''));
            },
            moment () {
                return (date) => {
                    let day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
                    return day
                }
            },
            error () {
                return this.$store.getters.error
            },
            loading () {
                return this.$store.getters.loading
            },
        },
        watch: {
            selectedUser (userName) {
                if (userName !== undefined) {
                    let userObj = this.users.find(user => {
                        return user.name === userName
                    })
                    this.addUserToSegment(userObj)
                }
            }
        },
        methods: {
            cancelImageUpload () {
                this.imageUploadDialog = false
                this.mediaUrl = undefined
            },
            selectImgFromContent (link) {
                this.mediaUrl = link
                console.log(link)
            },
            addImageLink (link){
                // console.log(link)
                this.mediaUrl = link
            },
            loadContent() {
                this.imageUploadDialog = true
                // let contentRef = this.$store.state.db.collection('content')
                // contentRef.get()
                //     .then(res => {
                //         let content = []
                //         res.docs.forEach(doc => {
                //             content.push(doc.data())
                //         })
                //         this.content = content
                //     })
            },
            sendText () {
                let id = uuidv1()
                let users = this.usersInSegment
                let msgObj = {
                    text:this.textMessage,
                    created: Date.now(),
                    id: id,
                    direction: 'outgoing'
                }
              let db = this.$store.state.db
                for(let key in users) {
                  let time = Date.now()
                  let userSMSRef = doc(db, 'users', this.uid + '/provisionedNumbers/'+ this.phoneNumber + '/sms/'+ users[key].phoneNumber)
                  let segmentContactRef = doc(db, 'users', this.uid + '/provisionedNumbers/' + this.phoneNumber + '/segments/'+ this.segmentId + '/contacts/' + users[key].phoneNumber)
                  let userMsgsRef = collection(db, 'users', this.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + users[key].phoneNumber + '/messages')
                  //console.log(users[key])
                  updateDoc(userSMSRef,{
                    lastActive: time,
                    lastMessage: msgObj.text
                  })
                      .then(()=> {
                      let outgoingMsg = {...msgObj}
                        outgoingMsg.created = time
                      if (this.mediaUrl) {
                        outgoingMsg.mediaUrl = this.mediaUrl
                        // if (this.textMessage !== '') {
                        //   outgoingMsg.text = ' '
                        // }
                      }
                        addDoc(userMsgsRef, outgoingMsg)
                      })
                      .then(() => {
                        updateDoc(segmentContactRef, {lastActive: time, lastMessage: msgObj.text})
                      })
                    .catch(err => {
                      this.$store.dispatch('setError', err)
                      console.log(err)
                    })
              }
              this.sendMessageDialog = false
            },
            removeUser (phoneNumber) {
              let db = this.$store.state.db
              let segmentRef = doc(db, 'users', this.uid, 'provisionedNumbers', this.phoneNumber, 'segments', this.segmentId, 'contacts', phoneNumber)
                deleteDoc(segmentRef)


            },
            addUserToSegment (userObj) {
              //console.log(userObj)
              let db = this.$store.state.db
              let segmentRef = doc(db, 'users', this.uid, 'provisionedNumbers', this.phoneNumber, 'segments', this.segmentId, 'contacts', userObj.phoneNumber)
                setDoc(segmentRef, userObj)
                .then(() => {
                     this.selectedUser = undefined
                 })
                .catch(err => {
                    this.$store.dispatch('setError', err)
                })
            },
            updateName () {
                this.editName = false
                this.segmentData.name = this.newSegmentName
                let db = this.$store.state.db
              let segmentRef = doc(db, 'users', this.uid, 'provisionedNumbers', this.phoneNumber, 'segments', this.segmentId)
                updateDoc(segmentRef, this.segmentData)
                  .catch(err => {
                    this.$store.dispatch('setError', err)
                  })
            },
            changeName () {
                this.newSegmentName = this.segmentData.name
                this.editName = true
            },
            onDismissed () {
                this.$store.dispatch('clearError')
            },
            deleteSegment () {
                this.$store.state.db.collection("segments").doc(this.segmentId).delete()
                .then(() => {
                    this.$router.push('/segments')
                })
            },
            loadUserData (phoneNumber) {
                //console.log(phoneNumber)
              let db = this.$store.state.db
              let userSMSRef = doc(db, 'users', this.uid + '/provisionedNumbers/'+ this.phoneNumber + '/sms/'+ phoneNumber)
                getDoc(userSMSRef)
                .then(res => {
                    this.loadedUserData = res.data()
                })
                 this.userDataDialog = true
            }
        }
    }
</script>
